// Standalone product/event pages that keep their own look and flows.
// Everything else is part of the main Rionick Studios site.
const EXCLUDED_PREFIXES = [
  "/ghar360",
  "/arrise",
  "/3D_Products",
  "/3d-space-announcement",
  "/BVM2026",
  "/portfolio-dashboard",
];

export const isRionickSitePage = (pathname = "") =>
  !EXCLUDED_PREFIXES.some((prefix) => pathname.startsWith(prefix));
